import { z } from 'zod';
import { moneySchema } from '../money';

/**
 * Register „Belege" am Artikel (ADR 0057): alle Belege, in denen der Artikel als
 * Position vorkommt — über Verkauf (Angebot/Auftrag/Lieferschein/Rechnung …),
 * Einkauf (Anfrage/Bestellung), Kommissionierung und Fertigung hinweg. Rein
 * lesend, eine Zeile je Beleg (Positionen desselben Artikels im selben Beleg
 * werden zu einer Menge summiert).
 *
 * `kind`/`status` sind die ROHEN Enum-Werte der jeweiligen Quelle
 * (SalesDocumentKind/-Status, PurchaseDocumentKind/PurchaseOrderStatus,
 * PickingStatus, ProductionOrderStatus) — die Labels/Badges übernimmt das
 * Frontend über die dort bereits vorhandenen Meta-Helfer je Quelle (keine
 * Label-Dopplung im Backend).
 */
export const articleDocumentSourceSchema = z.enum(['SALES', 'PURCHASE', 'PICKING', 'PRODUCTION']);
export type ArticleDocumentSource = z.infer<typeof articleDocumentSourceSchema>;

export const articleDocumentRowSchema = z.object({
  source: articleDocumentSourceSchema,
  /** ID des Belegs (Sales-/Purchase-Dokument, Kommissionierauftrag, Fertigungsauftrag) — fürs Verlinken. */
  id: z.string().uuid(),
  kind: z.string(),
  status: z.string(),
  number: z.string(),
  date: z.string().datetime(),
  /** Kunde/Lieferant — null bei Kommissionierung/Fertigung (kein Geschäftspartner-Bezug). */
  counterpartName: z.string().nullable(),
  projectId: z.string().uuid().nullable(),
  projectCode: z.string().nullable(),
  /** Menge dieses Artikels im Beleg (Positionen desselben Artikels summiert). */
  quantity: z.number(),
  unit: z.string().nullable(),
  /** Gesamtwert (netto) des GANZEN Belegs — nicht nur dieser Position. Null bei Kommissionierung/Fertigung. */
  amount: moneySchema.nullable(),
});
export type ArticleDocumentRow = z.infer<typeof articleDocumentRowSchema>;
